<div class="col-sm-6" style="text-align: center;">
  <h1>Acceso</h1>
  <div>
    <mat-form-field  class="form-field-width-full">
      <mat-label>Usuario</mat-label>
      <input [(ngModel)]="loginData.username"  matInput type="text" required>
      <mat-icon matSuffix>account_circle</mat-icon>
    </mat-form-field>
  </div>
  <div>
    <mat-form-field  class="form-field-width-full">
      <mat-label>Contraseña</mat-label>
      <input [(ngModel)]="loginData.password" data-press-enter="login()"  matInput type="password" required>
      <mat-icon matSuffix>lock</mat-icon>
    </mat-form-field>
  </div>

  <div class="col-sm-12">
      <button mat-raised-button class="btn btn-primary pull-right" (click)="login()" type="submit">Ingresar</button>
  </div>
</div>

